export var TestNames;
(function (TestNames) {
    TestNames[TestNames["Throughput"] = 0] = "Throughput";
    TestNames[TestNames["CallQuality"] = 1] = "CallQuality";
    TestNames[TestNames["TurnConnectivity"] = 2] = "TurnConnectivity";
    TestNames[TestNames["TurnConnectivity2"] = 3] = "TurnConnectivity2";
    TestNames[TestNames["VideoBandwidth"] = 4] = "VideoBandwidth";
    TestNames[TestNames["VideoBandwidth2"] = 5] = "VideoBandwidth2";
    TestNames[TestNames["Location"] = 6] = "Location";
    TestNames[TestNames["BandwidthSpeed"] = 7] = "BandwidthSpeed";
    TestNames[TestNames["Ping"] = 8] = "Ping";
    TestNames[TestNames["NetworkInformation"] = 9] = "NetworkInformation";
    TestNames[TestNames["VideoQuality"] = 10] = "VideoQuality";
    TestNames[TestNames["DNSLookup"] = 11] = "DNSLookup";
    TestNames[TestNames["VideoPlayback"] = 12] = "VideoPlayback";
    TestNames[TestNames["RCVTURNServers"] = 13] = "RCVTURNServers";
    TestNames[TestNames["GetUserMedia"] = 14] = "GetUserMedia";
    TestNames[TestNames["DNSSetup"] = 15] = "DNSSetup";
    TestNames[TestNames["VideoP2P"] = 16] = "VideoP2P";
    TestNames[TestNames["PrivateConnections"] = 17] = "PrivateConnections";
    TestNames[TestNames["DNSSettings"] = 18] = "DNSSettings";
    TestNames[TestNames["GPSLocation"] = 19] = "GPSLocation";
    TestNames[TestNames["HardwareAvailability"] = 20] = "HardwareAvailability";
    TestNames[TestNames["DeviceState"] = 21] = "DeviceState";
    TestNames[TestNames["MediaServerIp"] = 22] = "MediaServerIp";
    TestNames[TestNames["Traceroute"] = 23] = "Traceroute";
})(TestNames || (TestNames = {}));
export var AdditionalTestNames;
(function (AdditionalTestNames) {
    AdditionalTestNames[AdditionalTestNames["VideoPlayback"] = 0] = "VideoPlayback";
    AdditionalTestNames[AdditionalTestNames["RCVTURNServers"] = 1] = "RCVTURNServers";
    AdditionalTestNames[AdditionalTestNames["GetUserMedia"] = 2] = "GetUserMedia";
    AdditionalTestNames[AdditionalTestNames["DNSSetup"] = 3] = "DNSSetup";
    AdditionalTestNames[AdditionalTestNames["DNSSettings"] = 4] = "DNSSettings";
})(AdditionalTestNames || (AdditionalTestNames = {}));
export var TestTypes;
(function (TestTypes) {
    TestTypes[TestTypes["All"] = 0] = "All";
    TestTypes[TestTypes["Tcp"] = 1] = "Tcp";
    TestTypes[TestTypes["Udp"] = 2] = "Udp";
    TestTypes[TestTypes["Tls"] = 3] = "Tls";
    TestTypes[TestTypes["Bandwidth"] = 4] = "Bandwidth";
    TestTypes[TestTypes["Call"] = 5] = "Call";
    TestTypes[TestTypes["Speed"] = 6] = "Speed";
    TestTypes[TestTypes["Ping"] = 7] = "Ping";
    TestTypes[TestTypes["Location"] = 8] = "Location";
    TestTypes[TestTypes["NetworkInformation"] = 9] = "NetworkInformation";
})(TestTypes || (TestTypes = {}));
//# sourceMappingURL=config.js.map